module.exports = __webpack_public_path__ + "static/media/amazon_logo.816be223.png";